import React, { useState } from "react";
import { Mail, Lock, Sparkles, X, ArrowRight, ChevronDown } from "lucide-react";


const AuthModal = ({ onClose }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [showStateDropdown, setShowStateDropdown] = useState(false);
  const [showDistrictDropdown, setShowDistrictDropdown] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const indianStatesAndUTs = [
    // States
    "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
    "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka",
    "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram",
    "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu",
    "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal",
    // Union Territories
    "Andaman and Nicobar Islands", "Chandigarh", "Dadra and Nagar Haveli and Daman and Diu",
    "Delhi", "Jammu and Kashmir", "Ladakh", "Lakshadweep", "Puducherry"
  ];

  const stateDistrictsMap = {
    "Andhra Pradesh": ["Anantapur", "Chittoor", "East Godavari", "Guntur", "Krishna", "Kurnool", "Nellore", "Prakasam", "Srikakulam", "Visakhapatnam", "Vizianagaram", "West Godavari", "YSR Kadapa"],
    "Arunachal Pradesh": ["Anjaw", "Changlang", "Dibang Valley", "East Kameng", "East Siang", "Kamle", "Kra Daadi", "Kurung Kumey", "Lepa Rada", "Lohit", "Longding", "Lower Dibang Valley", "Lower Siang", "Lower Subansiri", "Namsai", "Pakke Kessang", "Papum Pare", "Shi Yomi", "Siang", "Tawang", "Tirap", "Upper Siang", "Upper Subansiri", "West Kameng", "West Siang"],
    "Assam": ["Baksa", "Barpeta", "Biswanath", "Bongaigaon", "Cachar", "Charaideo", "Chirang", "Darrang", "Dhemaji", "Dhubri", "Dibrugarh", "Goalpara", "Golaghat", "Hailakandi", "Hojai", "Jorhat", "Kamrup", "Kamrup Metropolitan", "Karbi Anglong", "Karimganj", "Kokrajhar", "Lakhimpur", "Majuli", "Morigaon", "Nagaon", "Nalbari", "Dima Hasao", "Sivasagar", "Sonitpur", "South Salmara-Mankachar", "Tinsukia", "Udalguri", "West Karbi Anglong"],
    "Bihar": ["Araria", "Arwal", "Aurangabad", "Banka", "Begusarai", "Bhagalpur", "Bhojpur", "Buxar", "Darbhanga", "East Champaran", "Gaya", "Gopalganj", "Jamui", "Jehanabad", "Kaimur", "Katihar", "Khagaria", "Kishanganj", "Lakhisarai", "Madhepura", "Madhubani", "Munger", "Muzaffarpur", "Nalanda", "Nawada", "Patna", "Purnia", "Rohtas", "Saharsa", "Samastipur", "Saran", "Sheikhpura", "Sheohar", "Sitamarhi", "Siwan", "Supaul", "Vaishali", "West Champaran"],
    "Chhattisgarh": ["Balod", "Baloda Bazar", "Balrampur", "Bastar", "Bemetara", "Bijapur", "Bilaspur", "Dantewada", "Dhamtari", "Durg", "Gariaband", "Gaurela Pendra Marwahi", "Janjgir Champa", "Jashpur", "Kabirdham", "Kanker", "Kondagaon", "Korba", "Koriya", "Mahasamund", "Mungeli", "Narayanpur", "Raigarh", "Raipur", "Rajnandgaon", "Sukma", "Surajpur", "Surguja"],
    "Goa": ["North Goa", "South Goa"],
    "Gujarat": ["Ahmedabad", "Amreli", "Anand", "Aravalli", "Banaskantha", "Bharuch", "Bhavnagar", "Botad", "Chhota Udaipur", "Dahod", "Dang", "Devbhoomi Dwarka", "Gandhinagar", "Gir Somnath", "Jamnagar", "Junagadh", "Kheda", "Kutch", "Mahisagar", "Mehsana", "Morbi", "Narmada", "Navsari", "Panchmahal", "Patan", "Porbandar", "Rajkot", "Sabarkantha", "Surat", "Surendranagar", "Tapi", "Vadodara", "Valsad"],
    "Haryana": ["Ambala", "Bhiwani", "Charkhi Dadri", "Faridabad", "Fatehabad", "Gurugram", "Hisar", "Jhajjar", "Jind", "Kaithal", "Karnal", "Kurukshetra", "Mahendragarh", "Nuh", "Palwal", "Panchkula", "Panipat", "Rewari", "Rohtak", "Sirsa", "Sonipat", "Yamunanagar"],
    "Himachal Pradesh": ["Bilaspur", "Chamba", "Hamirpur", "Kangra", "Kinnaur", "Kullu", "Lahaul and Spiti", "Mandi", "Shimla", "Sirmaur", "Solan", "Una"],
    "Jharkhand": ["Bokaro", "Chatra", "Deoghar", "Dhanbad", "Dumka", "East Singhbhum", "Garhwa", "Giridih", "Godda", "Gumla", "Hazaribagh", "Jamtara", "Khunti", "Koderma", "Latehar", "Lohardaga", "Pakur", "Palamu", "Ramgarh", "Ranchi", "Sahebganj", "Seraikela Kharsawan", "Simdega", "West Singhbhum"],
    "Karnataka": ["Bagalkot", "Ballari", "Belagavi", "Bengaluru Rural", "Bengaluru Urban", "Bidar", "Chamarajanagar", "Chikballapur", "Chikkamagaluru", "Chitradurga", "Dakshina Kannada", "Davanagere", "Dharwad", "Gadag", "Hassan", "Haveri", "Kalaburagi", "Kodagu", "Kolar", "Koppal", "Mandya", "Mysuru", "Raichur", "Ramanagara", "Shivamogga", "Tumakuru", "Udupi", "Uttara Kannada", "Vijayapura", "Yadgir"],
    "Kerala": ["Alappuzha", "Ernakulam", "Idukki", "Kannur", "Kasaragod", "Kollam", "Kottayam", "Kozhikode", "Malappuram", "Palakkad", "Pathanamthitta", "Thiruvananthapuram", "Thrissur", "Wayanad"],
    "Madhya Pradesh": ["Agar Malwa", "Alirajpur", "Anuppur", "Ashoknagar", "Balaghat", "Barwani", "Betul", "Bhind", "Bhopal", "Burhanpur", "Chhatarpur", "Chhindwara", "Damoh", "Datia", "Dewas", "Dhar", "Dindori", "Guna", "Gwalior", "Harda", "Hoshangabad", "Indore", "Jabalpur", "Jhabua", "Katni", "Khandwa", "Khargone", "Mandla", "Mandsaur", "Morena", "Narsinghpur", "Neemuch", "Niwari", "Panna", "Raisen", "Rajgarh", "Ratlam", "Rewa", "Sagar", "Satna", "Sehore", "Seoni", "Shahdol", "Shajapur", "Sheopur", "Shivpuri", "Sidhi", "Singrauli", "Tikamgarh", "Ujjain", "Umaria", "Vidisha"],
    "Maharashtra": ["Ahmednagar", "Akola", "Amravati", "Aurangabad", "Beed", "Bhandara", "Buldhana", "Chandrapur", "Dhule", "Gadchiroli", "Gondia", "Hingoli", "Jalgaon", "Jalna", "Kolhapur", "Latur", "Mumbai City", "Mumbai Suburban", "Nagpur", "Nanded", "Nandurbar", "Nashik", "Osmanabad", "Palghar", "Parbhani", "Pune", "Raigad", "Ratnagiri", "Sangli", "Satara", "Sindhudurg", "Solapur", "Thane", "Wardha", "Washim", "Yavatmal"],
    "Manipur": ["Bishnupur", "Chandel", "Churachandpur", "Imphal East", "Imphal West", "Jiribam", "Kakching", "Kamjong", "Kangpokpi", "Noney", "Pherzawl", "Senapati", "Tamenglong", "Tengnoupal", "Thoubal", "Ukhrul"],
    "Meghalaya": ["East Garo Hills", "East Jaintia Hills", "East Khasi Hills", "North Garo Hills", "Ri Bhoi", "South Garo Hills", "South West Garo Hills", "South West Khasi Hills", "West Garo Hills", "West Jaintia Hills", "West Khasi Hills"],
    "Mizoram": ["Aizawl", "Champhai", "Hnahthial", "Kolasib", "Khawzawl", "Lawngtlai", "Lunglei", "Mamit", "Saiha", "Saitual", "Serchhip"],
    "Nagaland": ["Dimapur", "Kiphire", "Kohima", "Longleng", "Mokokchung", "Mon", "Noklak", "Peren", "Phek", "Tuensang", "Wokha", "Zunheboto"],
    "Odisha": ["Angul", "Balangir", "Balasore", "Bargarh", "Bhadrak", "Boudh", "Cuttack", "Deogarh", "Dhenkanal", "Gajapati", "Ganjam", "Jagatsinghpur", "Jajpur", "Jharsuguda", "Kalahandi", "Kandhamal", "Kendrapara", "Kendujhar", "Khordha", "Koraput", "Malkangiri", "Mayurbhanj", "Nabarangpur", "Nayagarh", "Nuapada", "Puri", "Rayagada", "Sambalpur", "Subarnapur", "Sundargarh"],
    "Punjab": ["Amritsar", "Barnala", "Bathinda", "Faridkot", "Fatehgarh Sahib", "Fazilka", "Ferozepur", "Gurdaspur", "Hoshiarpur", "Jalandhar", "Kapurthala", "Ludhiana", "Mansa", "Moga", "Muktsar", "Nawanshahr", "Pathankot", "Patiala", "Rupnagar", "Sangrur", "Tarn Taran"],
    "Rajasthan": ["Ajmer", "Alwar", "Banswara", "Baran", "Barmer", "Bharatpur", "Bhilwara", "Bikaner", "Bundi", "Chittorgarh", "Churu", "Dausa", "Dholpur", "Dungarpur", "Ganganagar", "Hanumangarh", "Jaipur", "Jaisalmer", "Jalore", "Jhalawar", "Jhunjhunu", "Jodhpur", "Karauli", "Kota", "Nagaur", "Pali", "Pratapgarh", "Rajsamand", "Sawai Madhopur", "Sikar", "Sirohi", "Tonk", "Udaipur"],
    "Sikkim": ["East Sikkim", "North Sikkim", "South Sikkim", "West Sikkim"],
    "Tamil Nadu": ["Ariyalur", "Chengalpattu", "Chennai", "Coimbatore", "Cuddalore", "Dharmapuri", "Dindigul", "Erode", "Kallakurichi", "Kanchipuram", "Kanyakumari", "Karur", "Krishnagiri", "Madurai", "Mayiladuthurai", "Nagapattinam", "Namakkal", "Nilgiris", "Perambalur", "Pudukkottai", "Ramanathapuram", "Ranipet", "Salem", "Sivaganga", "Tenkasi", "Thanjavur", "Theni", "Thoothukudi", "Tiruchirappalli", "Tirunelveli", "Tirupattur", "Tiruppur", "Tiruvallur", "Tiruvannamalai", "Tiruvarur", "Vellore", "Viluppuram", "Virudhunagar"],
    "Telangana": ["Adilabad", "Bhadradri Kothagudem", "Hyderabad", "Jagtial", "Jangaon", "Jayashankar", "Jogulamba", "Kamareddy", "Karimnagar", "Khammam", "Komaram Bheem", "Mahabubabad", "Mahabubnagar", "Mancherial", "Medak", "Medchal", "Mulugu", "Nagarkurnool", "Nalgonda", "Narayanpet", "Nirmal", "Nizamabad", "Peddapalli", "Rajanna Sircilla", "Rangareddy", "Sangareddy", "Siddipet", "Suryapet", "Vikarabad", "Wanaparthy", "Warangal Rural", "Warangal Urban", "Yadadri Bhuvanagiri"],
    "Tripura": ["Dhalai", "Gomati", "Khowai", "North Tripura", "Sepahijala", "South Tripura", "Unakoti", "West Tripura"],
    "Uttar Pradesh": ["Agra", "Aligarh", "Ambedkar Nagar", "Amethi", "Amroha", "Auraiya", "Ayodhya", "Azamgarh", "Baghpat", "Bahraich", "Ballia", "Balrampur", "Banda", "Barabanki", "Bareilly", "Basti", "Bhadohi", "Bijnor", "Budaun", "Bulandshahr", "Chandauli", "Chitrakoot", "Deoria", "Etah", "Etawah", "Farrukhabad", "Fatehpur", "Firozabad", "Gautam Buddha Nagar", "Ghaziabad", "Ghazipur", "Gonda", "Gorakhpur", "Hamirpur", "Hapur", "Hardoi", "Hathras", "Jalaun", "Jaunpur", "Jhansi", "Kannauj", "Kanpur Dehat", "Kanpur Nagar", "Kasganj", "Kaushambi", "Kheri", "Kushinagar", "Lalitpur", "Lucknow", "Maharajganj", "Mahoba", "Mainpuri", "Mathura", "Mau", "Meerut", "Mirzapur", "Moradabad", "Muzaffarnagar", "Pilibhit", "Pratapgarh", "Prayagraj", "Raebareli", "Rampur", "Saharanpur", "Sambhal", "Sant Kabir Nagar", "Shahjahanpur", "Shamli", "Shrawasti", "Siddharthnagar", "Sitapur", "Sonbhadra", "Sultanpur", "Unnao", "Varanasi"],
    "Uttarakhand": ["Almora", "Bageshwar", "Chamoli", "Champawat", "Dehradun", "Haridwar", "Nainital", "Pauri", "Pithoragarh", "Rudraprayag", "Tehri", "Udham Singh Nagar", "Uttarkashi"],
    "West Bengal": ["Alipurduar", "Bankura", "Birbhum", "Cooch Behar", "Dakshin Dinajpur", "Darjeeling", "Hooghly", "Howrah", "Jalpaiguri", "Jhargram", "Kalimpong", "Kolkata", "Malda", "Murshidabad", "Nadia", "North 24 Parganas", "Paschim Bardhaman", "Paschim Medinipur", "Purba Bardhaman", "Purba Medinipur", "Purulia", "South 24 Parganas", "Uttar Dinajpur"],
    // Union Territories
    "Andaman and Nicobar Islands": ["Nicobar", "North and Middle Andaman", "South Andaman"],
    "Chandigarh": ["Chandigarh"],
    "Dadra and Nagar Haveli and Daman and Diu": ["Dadra and Nagar Haveli", "Daman", "Diu"],
    "Delhi": ["Central Delhi", "East Delhi", "New Delhi", "North Delhi", "North East Delhi", "North West Delhi", "Shahdara", "South Delhi", "South East Delhi", "South West Delhi", "West Delhi"],
    "Jammu and Kashmir": ["Anantnag", "Bandipora", "Baramulla", "Budgam", "Doda", "Ganderbal", "Jammu", "Kathua", "Kishtwar", "Kulgam", "Kupwara", "Poonch", "Pulwama", "Rajouri", "Ramban", "Reasi", "Samba", "Shopian", "Srinagar", "Udhampur"],
    "Ladakh": ["Kargil", "Leh"],
    "Lakshadweep": ["Lakshadweep"],
    "Puducherry": ["Karaikal", "Mahe", "Puducherry", "Yanam"]
  };

  // Check if user is entering state or district admin credentials
  const isStateAdmin = email === "state@gmail.com";
  const isDistrictAdmin = email === "district@gmail.com";

  // Static credentials
  const STATIC_CREDENTIALS = {
    "farmer@gmail.com": { password: "1234", role: "farmer", redirectRoute: "/farmer" },
    "govt@gmail.com": { password: "1234", role: "govt", redirectRoute: "/govt" },
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      const normalizedEmail = email.trim().toLowerCase();
      const cred = STATIC_CREDENTIALS[normalizedEmail];

      if (!cred || password !== cred.password) {
        setError("Invalid email or password.");
        setIsLoading(false);
        return;
      }

      if (normalizedEmail === "state@gmail.com" && !selectedState) {
        setError("Please select a state to manage");
        setIsLoading(false);
        return;
      }
      if (normalizedEmail === "district@gmail.com" && (!selectedState || !selectedDistrict)) {
        setError("Please select both state and district to manage");
        setIsLoading(false);
        return;
      }

      const userData = {
        email: normalizedEmail,
        role: cred.role,
        selectedState: selectedState || null,
        selectedDistrict: selectedDistrict || null,
      };

      localStorage.setItem("user", JSON.stringify(userData));
      localStorage.setItem("loggedIn", "true");
      window.location.href = cred.redirectRoute;
    } catch (err) {
      console.error("Auth error:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const overlayStyle = {
    position: "fixed",
    inset: 0,
    background: "rgba(0, 0, 0, 0.6)",
    backdropFilter: "blur(8px)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 999,
    animation: "fadeIn 0.3s ease-out",
  };

  const modalStyle = {
    width: "min(480px, 90vw)",
    background: "linear-gradient(145deg, rgba(255,255,255,0.95), rgba(236,253,245,0.95))",
    backdropFilter: "blur(20px)",
    borderRadius: "32px",
    padding: "0",
    boxShadow: "0 30px 80px rgba(16, 185, 129, 0.3), 0 0 0 1px rgba(255,255,255,0.5)",
    position: "relative",
    overflow: "hidden",
    animation: "slideUp 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)",
  };

  const closeButtonStyle = {
    position: "absolute",
    top: "20px",
    right: "20px",
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    background: "rgba(255, 255, 255, 0.8)",
    border: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.3s",
    zIndex: 10,
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  };

  const headerStyle = {
    padding: "clamp(24px, 5vw, 40px) clamp(20px, 5vw, 40px) 30px",
    background: "linear-gradient(135deg, #10b981, #059669)",
    position: "relative",
    overflow: "hidden",
  };

  const decorativeCircle1 = {
    position: "absolute",
    top: "-50px",
    right: "-50px",
    width: "150px",
    height: "150px",
    borderRadius: "50%",
    background: "rgba(255, 255, 255, 0.1)",
    filter: "blur(30px)",
  };

  const decorativeCircle2 = {
    position: "absolute",
    bottom: "-30px",
    left: "-30px",
    width: "100px",
    height: "100px",
    borderRadius: "50%",
    background: "rgba(255, 255, 255, 0.15)",
    filter: "blur(25px)",
  };

  const formContainerStyle = {
    padding: "clamp(20px, 5vw, 40px)",
  };

  const inputGroupStyle = {
    position: "relative",
    marginBottom: "20px",
  };

  const inputStyle = {
    width: "100%",
    padding: "14px 14px 14px 48px",
    borderRadius: "16px",
    border: "2px solid #e5e7eb",
    fontSize: "15px",
    transition: "all 0.3s",
    background: "white",
    outline: "none",
    fontFamily: "inherit",
  };

  const iconContainerStyle = {
    position: "absolute",
    left: "16px",
    top: "50%",
    transform: "translateY(-50%)",
    color: "#10b981",
    display: "flex",
    alignItems: "center",
  };

  const buttonStyle = {
    width: "100%",
    padding: "16px",
    background: isHovered
      ? "linear-gradient(135deg, #059669, #047857)"
      : "linear-gradient(135deg, #10b981, #059669)",
    color: "#fff",
    border: "none",
    borderRadius: "16px",
    fontWeight: 700,
    fontSize: "16px",
    cursor: "pointer",
    transition: "all 0.3s",
    boxShadow: "0 8px 20px rgba(16, 185, 129, 0.4)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    transform: isHovered ? "translateY(-2px)" : "translateY(0)",
  };

  const dropdownStyle = {
    position: "absolute",
    top: "100%",
    left: 0,
    right: 0,
    background: "white",
    border: "2px solid #e5e7eb",
    borderRadius: "12px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
    zIndex: 1000,
    maxHeight: "200px",
    overflowY: "auto",
    marginTop: "4px"
  };

  const dropdownItemStyle = {
    padding: "12px 16px",
    cursor: "pointer",
    fontSize: "14px",
    color: "#374151",
    borderBottom: "1px solid #f3f4f6",
    transition: "all 0.2s"
  };

  const stateSelectStyle = {
    width: "100%",
    padding: "14px 16px",
    borderRadius: "16px",
    border: "2px solid #e5e7eb",
    fontSize: "15px",
    transition: "all 0.3s",
    background: "white",
    outline: "none",
    fontFamily: "inherit",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    position: "relative"
  };

  return (
    <div style={overlayStyle} onClick={onClose}>
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes slideUp {
          from { 
            opacity: 0;
            transform: translateY(30px) scale(0.95);
          }
          to { 
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
        .input-focus:focus {
          border-color: #10b981 !important;
          box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.1) !important;
        }
        .social-button:hover {
          border-color: #10b981 !important;
          background: rgba(16, 185, 129, 0.05) !important;
          transform: translateY(-2px) !important;
          box-shadow: 0 4px 12px rgba(0,0,0,0.1) !important;
        }
        .role-card:hover {
          transform: translateX(4px);
          box-shadow: 0 4px 12px rgba(16, 185, 129, 0.15);
        }
        .close-btn:hover {
          background: rgba(239, 68, 68, 0.1) !important;
          color: #ef4444 !important;
          transform: rotate(90deg) !important;
        }
        .state-select:focus {
          border-color: #10b981 !important;
          box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.1) !important;
        }
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        @media (max-width: 600px) {
          .input-row {
            flex-direction: column !important;
            gap: 0 !important;
          }
        }
      `}</style>

      <div style={modalStyle} onClick={(e) => {
        e.stopPropagation();
        // Close dropdowns when clicking outside of them
        if (showStateDropdown && !e.target.closest('.state-dropdown-container')) {
          setShowStateDropdown(false);
        }
        if (showDistrictDropdown && !e.target.closest('.district-dropdown-container')) {
          setShowDistrictDropdown(false);
        }
      }}>
        {/* Close Button */}
        <button
          className="close-btn"
          style={closeButtonStyle}
          onClick={onClose}
        >
          <X size={20} color="#374151" />
        </button>

        {/* Header with Gradient */}
        <div style={headerStyle}>
          <div style={decorativeCircle1} />
          <div style={decorativeCircle2} />

          <div style={{ position: "relative", zIndex: 1 }}>
            <div style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              marginBottom: "8px",
              animation: "float 3s ease-in-out infinite"
            }}>
              <Sparkles size={24} color="white" />
              <h2 style={{
                margin: 0,
                color: "white",
                fontSize: "28px",
                fontWeight: 800,
              }}>
                Welcome Back!
              </h2>
            </div>
            <p style={{
              margin: "0 0 8px 0",
              color: "rgba(255, 255, 255, 0.9)",
              fontSize: "15px",
            }}>
              Enter your credentials to access your account
            </p>
          </div>
        </div>

        {/* Form */}
        <div style={formContainerStyle}>
          <form onSubmit={handleSubmit}>
            {error && (
              <div style={{
                background: "rgba(239, 68, 68, 0.1)",
                color: "#dc2626",
                padding: "12px 16px",
                borderRadius: "12px",
                marginBottom: "20px",
                fontSize: "14px",
                fontWeight: 500,
                border: "1px solid rgba(239, 68, 68, 0.2)"
              }}>
                {error}
              </div>
            )}

            {/* Email Input */}
            <div style={inputGroupStyle}>
              <div style={iconContainerStyle}>
                <Mail size={20} />
              </div>
              <input
                className="input-focus"
                style={inputStyle}
                type="email"
                placeholder="Username or Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            {/* Password Input */}
            <div style={inputGroupStyle}>
              <div style={iconContainerStyle}>
                <Lock size={20} />
              </div>
              <input
                className="input-focus"
                style={inputStyle}
                type="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            {/* State Selection for State Admin Login */}
            {isStateAdmin && (
              <div className="state-dropdown-container" style={{ position: "relative", marginBottom: "20px" }}>
                <label style={{
                  display: "block",
                  marginBottom: "8px",
                  fontSize: "14px",
                  fontWeight: 600,
                  color: "#374151",
                }}>
                  Select State to Manage
                </label>
                <div
                  className="state-select"
                  style={stateSelectStyle}
                  onClick={() => setShowStateDropdown(!showStateDropdown)}
                >
                  <span style={{
                    color: selectedState ? "#374151" : "#9ca3af",
                    fontSize: "15px"
                  }}>
                    {selectedState || "Choose state to manage"}
                  </span>
                  <ChevronDown size={20} color="#9ca3af"
                    style={{
                      transform: showStateDropdown ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "transform 0.3s ease"
                    }}
                  />
                </div>
                {showStateDropdown && (
                  <div style={dropdownStyle}>
                    {indianStatesAndUTs.map((state) => (
                      <div
                        key={state}
                        style={dropdownItemStyle}
                        onClick={() => {
                          setSelectedState(state);
                          setShowStateDropdown(false);
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.background = "#f3f4f6";
                          e.target.style.color = "#10b981";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.background = "white";
                          e.target.style.color = "#374151";
                        }}
                      >
                        {state}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {/* State and District Selection for District Admin Login */}
            {isDistrictAdmin && (
              <div style={{ marginBottom: "20px" }}>
                {/* State Selection */}
                <div className="state-dropdown-container" style={{ position: "relative", marginBottom: "16px" }}>
                  <label style={{
                    display: "block",
                    marginBottom: "8px",
                    fontSize: "14px",
                    fontWeight: 600,
                    color: "#374151",
                  }}>
                    Select State
                  </label>
                  <div
                    className="state-select"
                    style={stateSelectStyle}
                    onClick={() => setShowStateDropdown(!showStateDropdown)}
                  >
                    <span style={{
                      color: selectedState ? "#374151" : "#9ca3af",
                      fontSize: "15px"
                    }}>
                      {selectedState || "Choose state"}
                    </span>
                    <ChevronDown size={20} color="#9ca3af"
                      style={{
                        transform: showStateDropdown ? "rotate(180deg)" : "rotate(0deg)",
                        transition: "transform 0.3s ease"
                      }}
                    />
                  </div>
                  {showStateDropdown && (
                    <div style={dropdownStyle}>
                      {indianStatesAndUTs.map((state) => (
                        <div
                          key={state}
                          style={dropdownItemStyle}
                          onClick={() => {
                            setSelectedState(state);
                            setSelectedDistrict("");
                            setShowStateDropdown(false);
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.background = "#f3f4f6";
                            e.target.style.color = "#10b981";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.background = "white";
                            e.target.style.color = "#374151";
                          }}
                        >
                          {state}
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* District Selection */}
                {selectedState && stateDistrictsMap[selectedState] && (
                  <div className="district-dropdown-container" style={{ position: "relative" }}>
                    <label style={{
                      display: "block",
                      marginBottom: "8px",
                      fontSize: "14px",
                      fontWeight: 600,
                      color: "#374151",
                    }}>
                      Select District to Manage
                    </label>
                    <div
                      className="district-select"
                      style={stateSelectStyle}
                      onClick={() => setShowDistrictDropdown(!showDistrictDropdown)}
                    >
                      <span style={{
                        color: selectedDistrict ? "#374151" : "#9ca3af",
                        fontSize: "15px"
                      }}>
                        {selectedDistrict || `Choose district in ${selectedState}`}
                      </span>
                      <ChevronDown size={20} color="#9ca3af"
                        style={{
                          transform: showDistrictDropdown ? "rotate(180deg)" : "rotate(0deg)",
                          transition: "transform 0.3s ease"
                        }}
                      />
                    </div>
                    {showDistrictDropdown && (
                      <div style={dropdownStyle}>
                        {stateDistrictsMap[selectedState].map((district) => (
                          <div
                            key={district}
                            style={dropdownItemStyle}
                            onClick={() => {
                              setSelectedDistrict(district);
                              setShowDistrictDropdown(false);
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.background = "#f3f4f6";
                              e.target.style.color = "#10b981";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.background = "white";
                              e.target.style.color = "#374151";
                            }}
                          >
                            {district}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}

            {/* Submit Button */}
            <button
              type="submit"
              disabled={isLoading}
              style={{
                ...buttonStyle,
                opacity: isLoading ? 0.7 : 1,
                cursor: isLoading ? 'not-allowed' : 'pointer'
              }}
              onMouseEnter={() => !isLoading && setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              {isLoading ? (
                <>
                  <div style={{
                    width: "20px",
                    height: "20px",
                    border: "2px solid rgba(255,255,255,0.3)",
                    borderTop: "2px solid white",
                    borderRadius: "50%",
                    animation: "spin 1s linear infinite"
                  }} />
                  Processing...
                </>
              ) : (
                <>
                  Sign In
                  <ArrowRight size={20} />
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AuthModal;